// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/assets/v1/list_reference_bank.proto (package protos.vision.assets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ReferenceImage } from "./reference_image_pb";
import { file_vision_assets_v1_reference_image } from "./reference_image_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/assets/v1/list_reference_bank.proto.
 */
export const file_vision_assets_v1_list_reference_bank: GenFile = /*@__PURE__*/
  fileDesc("Cip2aXNpb24vYXNzZXRzL3YxL2xpc3RfcmVmZXJlbmNlX2JhbmsucHJvdG8SF3Byb3Rvcy52aXNpb24uYXNzZXRzLnYxIoIBChhMaXN0UmVmZXJlbmNlQmFua1JlcXVlc3QSSAoGcGFyYW1zGAEgASgLMjgucHJvdG9zLnZpc2lvbi5hc3NldHMudjEuTGlzdFJlZmVyZW5jZUJhbmtSZXF1ZXN0LlBhcmFtcxocCgZQYXJhbXMSEgoKcHJvamVjdF9pZBgBIAEoCSKtAQoZTGlzdFJlZmVyZW5jZUJhbmtSZXNwb25zZRJJCgZyZXN1bHQYASABKAsyOS5wcm90b3MudmlzaW9uLmFzc2V0cy52MS5MaXN0UmVmZXJlbmNlQmFua1Jlc3BvbnNlLlJlc3VsdBpFCgZSZXN1bHQSOwoKcmVmZXJlbmNlcxgBIAMoCzInLnByb3Rvcy52aXNpb24uYXNzZXRzLnYxLlJlZmVyZW5jZUltYWdlYgZwcm90bzM", [file_vision_assets_v1_reference_image]);

/**
 * @generated from message protos.vision.assets.v1.ListReferenceBankRequest
 */
export type ListReferenceBankRequest = Message<"protos.vision.assets.v1.ListReferenceBankRequest"> & {
  /**
   * @generated from field: protos.vision.assets.v1.ListReferenceBankRequest.Params params = 1;
   */
  params?: ListReferenceBankRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.ListReferenceBankRequest.
 * Use `create(ListReferenceBankRequestSchema)` to create a new message.
 */
export const ListReferenceBankRequestSchema: GenMessage<ListReferenceBankRequest> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_list_reference_bank, 0);

/**
 * @generated from message protos.vision.assets.v1.ListReferenceBankRequest.Params
 */
export type ListReferenceBankRequest_Params = Message<"protos.vision.assets.v1.ListReferenceBankRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;
};

/**
 * Describes the message protos.vision.assets.v1.ListReferenceBankRequest.Params.
 * Use `create(ListReferenceBankRequest_ParamsSchema)` to create a new message.
 */
export const ListReferenceBankRequest_ParamsSchema: GenMessage<ListReferenceBankRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_list_reference_bank, 0, 0);

/**
 * @generated from message protos.vision.assets.v1.ListReferenceBankResponse
 */
export type ListReferenceBankResponse = Message<"protos.vision.assets.v1.ListReferenceBankResponse"> & {
  /**
   * @generated from field: protos.vision.assets.v1.ListReferenceBankResponse.Result result = 1;
   */
  result?: ListReferenceBankResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.ListReferenceBankResponse.
 * Use `create(ListReferenceBankResponseSchema)` to create a new message.
 */
export const ListReferenceBankResponseSchema: GenMessage<ListReferenceBankResponse> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_list_reference_bank, 1);

/**
 * @generated from message protos.vision.assets.v1.ListReferenceBankResponse.Result
 */
export type ListReferenceBankResponse_Result = Message<"protos.vision.assets.v1.ListReferenceBankResponse.Result"> & {
  /**
   * @generated from field: repeated protos.vision.assets.v1.ReferenceImage references = 1;
   */
  references: ReferenceImage[];
};

/**
 * Describes the message protos.vision.assets.v1.ListReferenceBankResponse.Result.
 * Use `create(ListReferenceBankResponse_ResultSchema)` to create a new message.
 */
export const ListReferenceBankResponse_ResultSchema: GenMessage<ListReferenceBankResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_list_reference_bank, 1, 0);

